var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticStyle:{"color":"#FFD433"}},[_vm._v("Club San Francisco\n")])}
var staticRenderFns = []

export { render, staticRenderFns }